import { getConfigEnseigne } from '../utils/workspaceUtils';

export interface BrandConfigEntry {
    id: number;
    enseigne: string;
    environnement: string;
    fichier: string;
    key: string;
    value: string;
    comment: string | null;
    updated_at: string;
}

// Routed through the app's own nginx (same pattern as /dataquality-proxy/) rather than called
// directly: pgone.suite-one.fr has no CORS headers and requires X-API-KEY/X-API-SECRET, both
// added server-side by the proxy (see docker/*/nginx/conf.d/default.conf.template) so the
// frontend bundle never needs to carry the credentials.
const PGONE_PROXY_BASE = '/pgone-proxy';
// preproduction en développement (front/.env), production dans l'image de production (docker/prod/Dockerfile)
const CONFIG_ENV = process.env.REACT_APP_SUITEONECONFIG_ENV || 'preproduction';
const CONFIG_TYPE = 'beone';

export const getBrandConfig = async (enseigne: string): Promise<BrandConfigEntry[]> => {
    const response = await fetch(
        `${PGONE_PROXY_BASE}/v1/suiteoneconfig/${encodeURIComponent(getConfigEnseigne(enseigne))}/${CONFIG_TYPE}/${CONFIG_ENV}`,
        { method: 'GET', headers: { 'Content-Type': 'application/json' } }
    );
    // 404 = enseigne non configurée dans pgone (ex. monceau) : pas une erreur, les réglages gardent leurs valeurs par défaut
    if (response.status === 404) return [];
    if (!response.ok) throw new Error('Erreur de récupération de la configuration enseigne');
    const data = await response.json();
    return Array.isArray(data) ? data : (data.data || []);
};
